import React, { useCallback, useEffect, useMemo, useRef } from "react";
import { ThemeProvider } from "@swiggy-private/dls-web-theme/dist/components/ThemeProvider";
import { FontStyle } from "@swiggy-private/dls-web-theme/dist/components/Fonts";
import { GlobalStyles } from "@swiggy-private/dls-web-theme/dist/components/GlobalStyles";
import { resolveTheme, getDesignLanguage } from "@swiggy-private/aatm-nirbhar-ui/dist/lib/utils/theme";
import { loadTheme } from "@swiggy-private/dls-web-theme/dist/components/LoadTheme";
import { BaseCssTheme } from "@swiggy-private/dls-web-common/dist/components/themes/BaseCss/BaseCssTheme";
import { Payment } from "../Payment";
import { GetSwiggyHeadersResponsePayload } from "@swiggy-private/native-bridge/dist/interfaces";
import { Container } from "./styled";
import { BaseTheme } from "@swiggy-private/dls-web-common/dist/components/themes/precomputed/Base/BaseTheme";
import { InitalLoadingScreen } from "@swiggy-private/payment-ui";
import { CommonUIWrapper } from "@swiggy-private/core-ui";
import { GlobalDisableCopyPaste } from "../styles/Global";

type Dict<T> = { [header: string]: T | undefined };

function App(props: {
    apiHost: string;
    paymentHost: string;
    analyticsHost: string;
    headers: Dict<string>;
    path: string;
    simplPostLinkingRedirectUrl: string;
}): React.ReactElement {
    const linkRef = useRef<HTMLLinkElement | null>(null);
    const [currentTheme, setCurrentTheme] = React.useState<string>("base");
    const [isCssLoaded, setIsCssLoaded] = React.useState(false);

    const handleCssLoad = () => {
        window.cssThemeLoaded = true;
        setIsCssLoaded(true);
    };

    const onBack = useCallback(() => {
        return;
    }, []);

    useEffect(() => {
        const theme = window.selectedTheme || resolveTheme(props.headers as GetSwiggyHeadersResponsePayload);
        setCurrentTheme(theme);
        if (window.cssThemeLoaded === true) {
            handleCssLoad();
            return;
        }
        linkRef.current = loadTheme(theme);
        if (linkRef.current) {
            linkRef.current.addEventListener("load", handleCssLoad);
        }

        return () => {
            if (linkRef.current) {
                linkRef.current.removeEventListener("load", handleCssLoad);
                linkRef.current.remove();
                linkRef.current = null;
            }
        };
    }, [props.headers]);

    const designLanguage = useMemo(() => getDesignLanguage(currentTheme), [currentTheme]);

    return (
        <ThemeProvider
            theme={isCssLoaded ? BaseCssTheme : BaseTheme}
            colorMode="light"
            design_language={designLanguage}
            key={`${designLanguage}-${isCssLoaded}`}
        >
            <GlobalDisableCopyPaste />
            <GlobalStyles />
            <FontStyle />
            <Container>
                {isCssLoaded && designLanguage ? (
                    <Payment {...props} />
                ) : (
                    <CommonUIWrapper content={<InitalLoadingScreen />} header={<></>} onBack={onBack} />
                )}
            </Container>
        </ThemeProvider>
    );
}

export default App;
